var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filters-cont"},_vm._l((_vm.whitelist),function(fil){return _c(fil,{key:fil,tag:"component",attrs:{"filters":_vm.filters,"qunits":_vm.qunits,"is_mobile":_vm.is_mobile,"props":_vm.filter_props[fil]},on:{"update":_vm.update_filters}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }